module.exports = __webpack_public_path__ + "img/1_icn_sneaker_bak.ebd16e8d.png";